import React, { useState } from 'react';
import { FaWhatsapp, FaBuilding, FaBed, FaBath, FaChevronCircleDown, FaRulerCombined, FaChevronLeft, FaChevronRight, FaTimes, FaParking, FaWifi, FaDumbbell, FaSwimmingPool, FaShieldAlt, FaTree } from 'react-icons/fa';
import cover from "../images/projects/Islamabad Heights/islamabad_heights_cover.png";
import img1 from "../images/projects/Islamabad Heights/1.png";
import img2 from "../images/projects/Islamabad Heights/2.png";
import img3 from "../images/projects/Islamabad Heights/3.png";
import img4 from "../images/projects/Islamabad Heights/4.png";
import img5 from "../images/projects/Islamabad Heights/5.png";
import img6 from "../images/projects/Islamabad Heights/6.png";
import img7 from "../images/projects/Islamabad Heights/7.png";


const IslamabadHeights = () => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const floorPlans = [
    { id: 1, name: '2nd Floor Plan', image: img1 },
    { id: 2, name: '3rd Floor Plan', image: img2 },
    { id: 3, name: '7th Floor Plan', image: img3 },
    { id: 4, name: '10th Floor Plan', image: img4 },
    { id: 5, name: '11th Floor Plan', image: img5 },
    { id: 6, name: '13th Floor Plan', image: img6 },
    { id: 7, name: '15th Floor Plan', image: img7 },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === floorPlans.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? floorPlans.length - 1 : prev - 1));
  };

  const apartments = [
    { 
      type: 'Studio', 
      area: '356-816 sq ft', 
      units: 22, 
      floor: '2nd',
      image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=300&fit=crop',
      description: 'Modern studio apartments perfect for singles or couples seeking a cozy living space.'
    },
    { 
      type: '1 Bed', 
      area: '484-601 sq ft', 
      units: 6, 
      floor: '3rd-14th',
      image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=300&fit=crop',
      description: 'Elegant one-bedroom apartments with premium finishes and stunning views.'
    },
    { 
      type: '2 Bed', 
      area: '1010-1341 sq ft', 
      units: 8, 
      floor: '3rd-14th',
      image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=300&fit=crop',
      description: 'Spacious two-bedroom residences ideal for families with panoramic city views.'
    },
    { 
      type: '3 Bed', 
      area: '1488 sq ft', 
      units: 1, 
      floor: '3rd-14th',
      image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=300&fit=crop',
      description: 'Luxurious three-bedroom apartment with expansive living spaces and premium amenities.'
    },
    { 
      type: 'Penthouse', 
      area: '1020-2092 sq ft', 
      units: 2, 
      floor: '15th-17th',
      image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=300&fit=crop',
      description: 'Exclusive penthouse suites with private terraces and breathtaking 360-degree views.'
    },
  ];

  const amenities = [
    { name: '7 ft Wide Corridors', icon: <FaBuilding className="text-3xl" />, description: 'Spacious, well-lit hallways' },
    { name: 'Spacious Balconies', icon: <FaBuilding className="text-3xl" />, description: 'Private outdoor spaces' },
    { name: 'Modern Kitchens', icon: <FaBuilding className="text-3xl" />, description: 'European-style fittings' },
    { name: 'Elevator Access', icon: <FaBuilding className="text-3xl" />, description: 'High-speed elevators' },
    { name: 'Open Terrace Spaces', icon: <FaBuilding className="text-3xl" />, description: 'Rooftop community areas' },
    { name: 'Lobby Lounge', icon: <FaBuilding className="text-3xl" />, description: 'Elegant reception area' },
    { name: 'Secure Parking', icon: <FaParking className="text-3xl" />, description: 'Covered parking spaces' },
    { name: 'High-Speed WiFi', icon: <FaWifi className="text-3xl" />, description: 'Fiber optic connectivity' },
    { name: 'Fitness Center', icon: <FaDumbbell className="text-3xl" />, description: 'State-of-the-art gym' },
    { name: 'Swimming Pool', icon: <FaSwimmingPool className="text-3xl" />, description: 'Infinity pool with views' },
    { name: '24/7 Security', icon: <FaShieldAlt className="text-3xl" />, description: 'CCTV and guard service' },
    { name: 'Landscaped Gardens', icon: <FaTree className="text-3xl" />, description: 'Green outdoor spaces' },
  ];

  const features = [
    { label: 'Total Floors', value: '17' },
    { label: 'Total Apartments', value: '150+' },
    { label: 'Apartment Types', value: '5' },
    { label: 'Starting Price', value: '5.7M PKR' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white font-sans">
      {/* Hero Section */}
      <div className="relative h-screen flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: `url(${cover})` }}>
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent"></div>
        <div className="relative z-10 text-left px-6 max-w-5xl w-full mx-auto">
          <div className="animate-fadeInUp">
            <span className="inline-block bg-amber-500 text-white px-6 py-2 rounded-full text-sm font-semibold mb-4 tracking-wider">PREMIUM LIVING</span>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 leading-tight">
              Islamabad <br />
              <span className="text-amber-400">Heights</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 mb-3">Luxury Living in the Heart of Islamabad</p>
            <p className="text-lg text-gray-300 mb-8 max-w-2xl">Experience panoramic views and modern elegance with our exclusive collection of studio, 1, 2, 3 bedroom apartments and penthouses.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => window.open('https://wa.me/923487172565', '_blank')}
                className="bg-green-600 hover:bg-green-700 text-white px-10 py-4 rounded-full flex items-center justify-center gap-3 text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                <FaWhatsapp size={24} /> Book Now
              </button>
              <button 
                onClick={() => setIsPaymentModalOpen(true)}
                className="bg-amber-600 hover:bg-amber-700 text-white px-10 py-4 rounded-full flex items-center justify-center gap-3 text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                Payment Plan
              </button>
            </div>
          </div>
        </div>
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center">
          <span className="text-white text-sm mb-2 opacity-70">Scroll to explore</span>
          <div className="animate-bounce bg-white/20 p-3 rounded-full">
            <FaChevronCircleDown className="text-white text-2xl" />
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="bg-white shadow-lg -mt-6 relative z-20 rounded-2xl max-w-5xl mx-auto px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {features.map((feature, idx) => (
          <div key={idx} className="text-center">
            <p className="text-3xl font-bold text-amber-600">{feature.value}</p>
            <p className="text-gray-600 text-sm">{feature.label}</p>
          </div>
        ))}
      </div>

      {/* Payment Plan Modal */}
      {isPaymentModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto p-6 md:p-8 relative shadow-2xl animate-scaleIn">
            <button 
              onClick={() => setIsPaymentModalOpen(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 bg-gray-100 hover:bg-gray-200 p-2 rounded-full transition-all"
            >
              <FaTimes size={20} />
            </button>
            <h2 className="text-3xl font-bold mb-2 text-center text-gray-800">Flexible Payment Plan</h2>
            <p className="text-center text-gray-500 mb-8">Choose your dream home with our easy installment options</p>
            
            <div className="bg-gradient-to-r from-amber-500 to-amber-600 text-white p-6 rounded-2xl mb-8">
              <h3 className="font-bold text-xl">25% Down Payment</h3>
              <p className="opacity-90">+ 36 Monthly Installments + 10% on Possession</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-50 p-6 rounded-2xl hover:shadow-lg transition-shadow border border-gray-100">
                <div className="flex items-center gap-3 mb-3">
                  <span className="bg-amber-100 text-amber-600 p-2 rounded-lg">🏢</span>
                  <h4 className="font-bold text-xl text-gray-800">Studio</h4>
                </div>
                <p className="text-gray-600 mb-3">Starting from 5.7 Million PKR</p>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between"><span className="text-gray-500">Down Payment:</span><span className="font-semibold">1.42M PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Monthly:</span><span className="font-semibold">102,844 PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Possession:</span><span className="font-semibold">569,600 PKR</span></li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-2xl hover:shadow-lg transition-shadow border border-gray-100">
                <div className="flex items-center gap-3 mb-3">
                  <span className="bg-amber-100 text-amber-600 p-2 rounded-lg">🛋️</span>
                  <h4 className="font-bold text-xl text-gray-800">1 Bed</h4>
                </div>
                <p className="text-gray-600 mb-3">Starting from 7.0 Million PKR</p>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between"><span className="text-gray-500">Down Payment:</span><span className="font-semibold">1.75M PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Monthly:</span><span className="font-semibold">126,714 PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Possession:</span><span className="font-semibold">701,800 PKR</span></li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-2xl hover:shadow-lg transition-shadow border border-gray-100">
                <div className="flex items-center gap-3 mb-3">
                  <span className="bg-amber-100 text-amber-600 p-2 rounded-lg">🛏️</span>
                  <h4 className="font-bold text-xl text-gray-800">2 Bed</h4>
                </div>
                <p className="text-gray-600 mb-3">Starting from 14.6 Million PKR</p>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between"><span className="text-gray-500">Down Payment:</span><span className="font-semibold">3.66M PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Monthly:</span><span className="font-semibold">264,424 PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Possession:</span><span className="font-semibold">1.46M PKR</span></li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-2xl hover:shadow-lg transition-shadow border border-gray-100">
                <div className="flex items-center gap-3 mb-3">
                  <span className="bg-amber-100 text-amber-600 p-2 rounded-lg">🏠</span>
                  <h4 className="font-bold text-xl text-gray-800">3 Bed</h4>
                </div>
                <p className="text-gray-600 mb-3">Starting from 21.5 Million PKR</p>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between"><span className="text-gray-500">Down Payment:</span><span className="font-semibold">5.39M PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Monthly:</span><span className="font-semibold">389,567 PKR</span></li>
                  <li className="flex justify-between"><span className="text-gray-500">Possession:</span><span className="font-semibold">2.15M PKR</span></li>
                </ul>
              </div>
            </div>
            
            <div className="mt-6 bg-amber-50 p-4 rounded-xl border border-amber-200">
              <p className="text-sm text-gray-600 text-center">✨ <span className="font-semibold">Penthouse Suites</span> starting from 21.0 Million PKR • Down: 5.25M • Monthly: 379,600 • Possession: 2.1M</p>
            </div>
            <p className="text-xs text-gray-400 text-center mt-4">* All prices are subject to change. Contact sales team for current availability.</p>
          </div>
        </div>
      )}

      {/* Apartments Section */}
      <section className="py-20 px-6 max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-amber-600 font-semibold tracking-wider uppercase text-sm">Our Collection</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2">Apartment Types</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mt-4"></div>
          <p className="text-gray-500 mt-4 max-w-2xl mx-auto">Discover our range of thoughtfully designed living spaces crafted for modern lifestyles</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {apartments.map((apt, idx) => (
            <div key={idx} className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-2">
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={apt.image} 
                  alt={apt.type}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="text-white text-2xl font-bold">{apt.type}</span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-amber-100 text-amber-700 text-xs font-semibold px-3 py-1 rounded-full">Floor {apt.floor}</span>
                  <span className="text-gray-500 text-sm">{apt.units} Units</span>
                </div>
                <p className="text-gray-600 text-sm mb-4">{apt.description}</p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <span className="text-amber-600 font-bold">{apt.area}</span>
                  <button className="text-amber-600 hover:text-amber-700 font-semibold text-sm flex items-center gap-1">
                    View Details →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Amenities Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-amber-600 font-semibold tracking-wider uppercase text-sm">Luxury Living</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2">Premium Amenities</h2>
            <div className="w-20 h-1 bg-amber-500 mx-auto mt-4"></div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {amenities.map((item, idx) => (
              <div key={idx} className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 text-center border border-gray-100">
                <div className="text-amber-500 mb-3 flex justify-center">{item.icon}</div>
                <h4 className="font-bold text-gray-800 text-sm">{item.name}</h4>
                <p className="text-gray-400 text-xs mt-1">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Floor Plans Carousel */}
      <section className="py-20 px-6 max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-amber-600 font-semibold tracking-wider uppercase text-sm">Layouts</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2">Floor Plans</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mt-4"></div>
          <p className="text-gray-500 mt-4">Explore our thoughtfully designed floor plans for every lifestyle</p>
        </div>
        <div className="relative">
          <div className="overflow-hidden rounded-3xl shadow-2xl bg-white">
            <div className="relative h-[600px] md:h-[700px] flex items-center justify-center">
              {floorPlans.map((plan, idx) => (
                <div 
                  key={plan.id}
                  className={`absolute inset-0 transition-all duration-700 flex items-center justify-center p-4 ${
                    idx === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'
                  }`}
                >
                  <img 
                    src={plan.image} 
                    alt={plan.name}
                    className="h-full w-auto object-contain max-h-[600px] md:max-h-[650px]"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-6 text-center">
                    <h3 className="text-2xl font-bold text-white">{plan.name}</h3>
                  </div>
                </div>
              ))}
            </div>
            <button 
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white p-4 rounded-full shadow-xl transition-all z-10 hover:scale-110"
            >
              <FaChevronLeft className="text-gray-700" />
            </button>
            <button 
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white p-4 rounded-full shadow-xl transition-all z-10 hover:scale-110"
            >
              <FaChevronRight className="text-gray-700" />
            </button>
          </div>
          <div className="flex justify-center mt-6 gap-3">
            {floorPlans.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSlide(idx)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  idx === currentSlide ? 'bg-amber-600 w-8' : 'bg-gray-300 w-2 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="relative py-20 px-6 bg-cover bg-center bg-fixed" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1920&h=600&fit=crop')" }}>
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Find Your Dream Home?</h2>
          <p className="text-xl text-gray-300 mb-8">Contact us today to schedule a viewing and explore our exclusive offers</p>
          <button 
            onClick={() => window.open('https://wa.me/923487172565', '_blank')}
            className="bg-green-600 hover:bg-green-700 text-white px-12 py-4 rounded-full flex items-center justify-center gap-3 text-lg font-semibold mx-auto transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            <FaWhatsapp size={24} /> Book Your Visit Now
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold mb-3">Islamabad Heights</h3>
              <p className="text-gray-400 text-sm">Luxury living with breathtaking views in the heart of Islamabad's most prestigious neighborhood.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-3">Quick Links</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><button onClick={() => setIsPaymentModalOpen(true)} className="hover:text-amber-400 transition-colors">Payment Plan</button></li>
                <li><button className="hover:text-amber-400 transition-colors">Floor Plans</button></li>
                <li><button className="hover:text-amber-400 transition-colors">Contact Sales</button></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-3">Contact</h4>
              <button 
                onClick={() => window.open('https://wa.me/923487172565', '_blank')}
                className="bg-green-600 hover:bg-green-700 px-6 py-2 rounded-full flex items-center gap-2 transition-colors text-sm"
              >
                <FaWhatsapp /> +92 348 7172565
              </button>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-6 text-center">
            <p className="text-gray-500 text-sm">© 2026 Islamabad Heights. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Custom CSS for animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 1s ease-out;
        }
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-scaleIn {
          animation: scaleIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default IslamabadHeights;